import { ContactDetailsResponse } from '../../../../../../types'

export interface InformationProps {
  data: ContactDetailsResponse
}
